/** `/admin`: the hardened admin sign-in (email + password + TOTP). Once signed in as admin, renders
 *  the admin panel. */
import { useState, type FormEvent } from "react";
import { useAuth } from "../AuthProvider";
import { useAdminLogin } from "../../api/auth";
import { AdminPanel } from "./AdminPanel";
import { AuthShell, Button, FormError, TextField, apiErrorMessage } from "../../components/ui";
import logoRed from "../../assets/brand/logo-borenius-red.svg";

export function AdminPage() {
  const { user } = useAuth();
  if (user?.kind === "admin") return <AdminPanel />;
  return <AdminLogin />;
}

function AdminLogin() {
  const adminLogin = useAdminLogin();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [totp, setTotp] = useState("");

  async function submit(e: FormEvent) {
    e.preventDefault();
    try {
      await adminLogin.mutateAsync({ email, password, totp });
      // success flips `useAuth().user` to the admin → AdminPage re-renders the panel.
    } catch {
      /* error rendered below */
    }
  }

  return (
    <AuthShell>
      <img src={logoRed} alt="Borenius" className="mb-6 h-6" />
      <p className="t-overline text-brand">Administrator</p>
      <h1 className="mt-1 font-display text-fluid-xl font-semibold text-ink">Administrator sign-in</h1>
      <form onSubmit={submit} className="mt-5 flex flex-col gap-4">
        <TextField label="Email" name="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" />
        <TextField label="Password" name="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />
        <TextField
          label="Authenticator code"
          name="totp"
          inputMode="numeric"
          autoComplete="one-time-code"
          required
          value={totp}
          onChange={(e) => setTotp(e.target.value)}
          placeholder="6-digit code"
        />
        {adminLogin.error && <FormError>{apiErrorMessage(adminLogin.error)}</FormError>}
        <Button type="submit" disabled={adminLogin.isPending} className="w-full">
          {adminLogin.isPending ? "Signing in…" : "Sign in"}
        </Button>
      </form>
    </AuthShell>
  );
}
